import { Observable } from 'rxjs';

import { Response } from '@shure/shared/angular/data-access/system-api/models';

import { LimiterChannel } from '../models';

export abstract class LimiterApiService {
	/**
	 * Get channel that supports limiter.
	 */
	public abstract getChannel$(channelId: string): Observable<LimiterChannel>;

	/**
	 * enable/disable limiter for channel.
	 */
	public abstract toggleLimiter(channelId: string, enabled: boolean): Observable<Response<void, string>>;

	/**
	 * sets limiter threshold for channel.
	 */
	public abstract setThreshold(channelId: string, threshold: number): Observable<Response<void, string>>;
}
